import { createContext, useContext, useState, useCallback } from "react";
import tr from "@/i18n/tr";

const dictionaries = { tr };

const LanguageContext = createContext(null);
export const useLang = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [lang] = useState("tr"); // TR default; EN/DE are "yakında" (coming soon)

  const t = useCallback(
    (key) => {
      const dict = dictionaries[lang] || tr;
      return key.split(".").reduce((o, k) => (o ? o[k] : undefined), dict) ?? key;
    },
    [lang]
  );

  return <LanguageContext.Provider value={{ lang, t }}>{children}</LanguageContext.Provider>;
};
